export const DOCUMENTS_INFO = {
  hojaResumen: {
    title: "Hoja de resumen",
    required: true,
  },
  contratoAnexos: {
    title: "Contrato y anexos",
    required: true,
  },
  seguroDesgravamen: {
    title: "Seguro Desgravamen",
    required: true,
  },
}; 